import axiosInstance from '@/setup/axios/axiosInstance';

import { InventoryStocktakeRow } from '../types';

interface ApiStocktakeItem {
  id: string;
  stocktake_no?: string;
  code?: string;
  name?: string;
  company_id?: string;
  company_name?: string;
  store_id?: string;
  store_name?: string;
  warehouse_id?: string;
  warehouse_name?: string;
  date?: string;
  stocktake_date?: string;
  status?: string;
  status_code?: string;
  status_display?: string;
  note?: string;
}

interface ApiStocktakeListResponse {
  results?: ApiStocktakeItem[];
  count?: number;
  page?: number;
  page_size?: number;
  total_pages?: number;
}

const UUID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

const mapApiStocktake = (row: ApiStocktakeItem): InventoryStocktakeRow => ({
  id: row.id,
  code: row.stocktake_no || row.code || '',
  name: row.name || row.stocktake_no || row.code || '',
  store_name: row.store_name || row.warehouse_name || row.store_id || row.warehouse_id || '',
  date: row.date || row.stocktake_date || '',
  status: row.status_code || row.status || '',
  company_id: row.company_id || '',
  company_name: row.company_name || '',
  note: row.note || '',
});

export interface GetStocktakesParams {
  companyId?: string;
  search?: string;
  status?: string;
  page?: number;
  pageSize?: number;
}

export interface GetStocktakesResponse {
  results: InventoryStocktakeRow[];
  count: number;
  page: number;
  pageSize: number;
  totalPages: number;
}

export async function getStocktakes(params: GetStocktakesParams = {}): Promise<GetStocktakesResponse> {
  const query = new URLSearchParams();
  if (params.companyId && UUID_PATTERN.test(params.companyId)) {
    query.append('company', params.companyId);
  }
  if (params.search?.trim()) {
    query.append('search', params.search.trim());
  }
  if (params.status && params.status !== 'all') {
    query.append('status', params.status);
  }
  if (params.page) {
    query.append('page', String(params.page));
  }
  if (params.pageSize && params.pageSize > 0) {
    query.append('page_size', String(params.pageSize));
  }

  const qs = query.toString();
  const response = await axiosInstance.get<ApiStocktakeListResponse | ApiStocktakeItem[]>(
    `/inventory/stocktakes/${qs ? `?${qs}` : ''}`
  );
  const data = response.data;
  const payload = Array.isArray(data) ? data : (data.results || []);

  if (Array.isArray(data)) {
    return {
      results: payload.map(mapApiStocktake),
      count: payload.length,
      page: 1,
      pageSize: payload.length,
      totalPages: 1,
    };
  }

  return {
    results: payload.map(mapApiStocktake),
    count: data.count || payload.length,
    page: data.page || params.page || 1,
    pageSize: data.page_size || params.pageSize || payload.length,
    totalPages: data.total_pages || 1,
  };
}
